/**
 * Management accounting reports
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The CurrentPeriodData model module.
* @module model/CurrentPeriodData
* @version 1.0.0
*/
export default class CurrentPeriodData {
    /**
    * Constructs a new <code>CurrentPeriodData</code>.
    * @alias module:model/CurrentPeriodData
    * @class
    * @param _date {Date} 
    * @param revenue {Number} 
    * @param expenses {Number} 
    * @param netProfit {Number} 
    * @param dividends {Number} 
    */

    constructor(_date, revenue, expenses, netProfit, dividends) {
        

        
        

        this['date'] = _date;this['revenue'] = revenue;this['expenses'] = expenses;this['netProfit'] = netProfit;this['dividends'] = dividends;

        
    }

    /**
    * Constructs a <code>CurrentPeriodData</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CurrentPeriodData} obj Optional instance to populate.
    * @return {module:model/CurrentPeriodData} The populated <code>CurrentPeriodData</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CurrentPeriodData();

            
            
            

            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'Date');
            }
            if (data.hasOwnProperty('revenue')) {
                obj['revenue'] = ApiClient.convertToType(data['revenue'], 'Number');
            }
            if (data.hasOwnProperty('expenses')) {
                obj['expenses'] = ApiClient.convertToType(data['expenses'], 'Number');
            }
            if (data.hasOwnProperty('netProfit')) {
                obj['netProfit'] = ApiClient.convertToType(data['netProfit'], 'Number');
            }
            if (data.hasOwnProperty('dividends')) {
                obj['dividends'] = ApiClient.convertToType(data['dividends'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {Date} date
    */
    date = undefined;
    /**
    * @member {Number} revenue
    */
    revenue = undefined;
    /**
    * @member {Number} expenses
    */
    expenses = undefined;
    /**
    * @member {Number} netProfit
    */
    netProfit = undefined;
    /**
    * @member {Number} dividends
    */
    dividends = undefined;








}


